import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconDomo = ({
  title = "Domo",
  viewBoxWidth = 200,
  viewBoxHeight = 56,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g
      id="IconDomo"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M173.637,0.142377358 C160.874,0.142377358 150.23,9.72550943 147.797,22.4530943 L147.797,0.142377358 L121.3585,27.9970943 L94.995,0.142377358 L94.995,22.4530943 C92.562,9.72524528 81.91775,0.142377358 69.15475,0.142377358 C56.39325,0.142377358 45.75,9.72339623 43.31575,22.4488679 C42.3725,17.5216604 40.1995,13.065434 37.1485,9.45449057 C32.32025,3.74064151 25.297,0.142377358 17.4775,0.142377358 L0,0.142377358 L0,55.8531321 L17.4775,55.8531321 C25.29675,55.8531321 32.32,52.2548679 37.148,46.541283 C40.19925,42.9306038 42.37225,38.4741132 43.31575,33.5466415 C45.75025,46.2721132 56.39325,55.8531321 69.15475,55.8531321 C81.91775,55.8531321 92.562,46.27 94.995,33.5421509 L94.995,55.8531321 L103.732,55.8531321 L103.732,22.5389434 L121.3585,41.1623774 L138.90825,22.5389434 L138.90825,55.8531321 L147.797,55.8531321 L147.797,33.5418868 C150.23,46.2697358 160.87425,55.8531321 173.637,55.8531321 C188.19675,55.8531321 200,43.3815094 200,27.9976226 C200,12.6134717 188.19675,0.142377358 173.637,0.142377358 Z M18.6225,46.5410189 L8.737,46.5410189 L8.737,9.45422642 L18.629,9.45422642 C27.807,10.0815849 35.069,18.1410943 35.069,27.9973585 C35.069,37.856 27.80375,45.9173585 18.6225,46.5410189 Z M69.15475,46.5846038 C59.43925,46.5846038 51.56325,38.2627925 51.56325,27.9973585 C51.56325,17.7319245 59.43925,9.41011321 69.15475,9.41011321 C78.87025,9.41011321 86.74625,17.7319245 86.74625,27.9973585 C86.74625,38.2627925 78.87025,46.5846038 69.15475,46.5846038 Z M173.637,46.5846038 C163.9215,46.5846038 156.04575,38.2627925 156.04575,27.9973585 C156.04575,17.7319245 163.9215,9.41011321 173.637,9.41011321 C183.35225,9.41011321 191.2285,17.7319245 191.2285,27.9973585 C191.2285,38.2627925 183.35225,46.5846038 173.637,46.5846038 Z"
        fill="#99CCEE"
        fillRule="nonzero"
      />
    </g>
  </Svg.Icon>
)

export default IconDomo
